export default {
  plate: /^([0-9aA-zZ]{5,8})$/,
  vin: /^([a-zA-Z0-9]{13}[0-9]{4})$/,
  basicNotAllowed: /[^a-zA-Z0-9]/g,
  kilometers: /^\d{1,8}$/g,
  sharedAccessRoute: /\/publico\/ver\/([a-zA-Z]|[0-9]|-){36}$/,
  spaceAndComma: / |,/g,
};
